import { warn, error } from '@xhs/logger'

function deprecatedStr(deprecated, now, changelog = '') {
  return `[OzoneBridge] ${deprecated} was deprecated, please use ${now}.${changelog ? ` Changelog for ${changelog}` : ''}`
}

export function warnDeprecated(deprecated, now, changelog) {
  warn(deprecatedStr(deprecated, now, changelog))
}

export function errorDeprecated(deprecated, now, changelog) {
  error(deprecatedStr(deprecated, now, changelog))
}
